import React, { useState } from 'react'
import { Row, Col, Button, Spinner, FormGroup, Form, Modal, ModalHeader, ModalBody, Label } from 'reactstrap';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import http from '../../CommonAxios'
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import { checkData } from '../../ObjectExist';

const AddPopop = (props) => {
    const [loader, setLoader] = useState(false);
    const [image, setImage] = useState("");

    const { register: popupInput, handleSubmit: popupSubmit, formState: { errors }, reset } = useForm();
    const handleFileInput = (e) => {
        setImage(e.target.files[0])
    }
    
    const onAddPopup = (data) => {
        setLoader(true);
        console.log('add popup data', data)
        let formData = new FormData();
        formData.append("admin_id", checkData(props.user) ? props.user.id : '');
        formData.append("title", data.title);
        formData.append("link", data.link);
        formData.append("seconds", data.seconds);
        formData.append("image", image);
        formData.append("status", data.status);
        http.post(`popup/add`, formData).then((res) => {
            console.log('response', res)
            setLoader(false);
            if (res.data.s === 1) {
                Swal.fire({ icon: 'success', title: 'Success', text: res.data.msg, });
                props.setAddmodal(false); props.onApiInteg(); reset();
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: res.data.message, });
            }
        }).catch(function (err) {
            setLoader(false);
        });
    };
    return (
        <>
            {loader && <div className="formLoader"><Spinner /></div>}
            <Modal isOpen={props.addmodal} toggle={props.addmodal} scrollable={true} size="lg" className='addModal'>
                <ModalHeader toggle={props.toggleAdd}>Add New Popup</ModalHeader>
                <ModalBody>
                    <Form onSubmit={popupSubmit(onAddPopup)} >
                        <Row className="mx-0 addModal">
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="title">Enter title<span className="text-danger">*</span></Label>
                                    <input {...popupInput("title", { required: 'Please Enter Title' })} className="form-control-sm form-control" placeholder="Enter title*" id="title" />
                                    {errors.title && <span className="text-danger d-block error">{errors.title.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="uploadpopupImage">Upload Image</Label>
                                    <input {...popupInput("popupImage", { required: false })} type="file" onChange={handleFileInput} accept=".jpg, .jpeg, .png" className="form-control-sm form-control" id="uploadpopupImage" />
                                    <span className="text-info d-block">400/200</span>
                                    {errors.popupImage && <span className="text-danger d-block error">{errors.popupImage.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="link">Link<span className="text-danger">*</span></Label>
                                    <input {...popupInput("link", { required: 'Please Enter link' })} type="tel" className="form-control-sm form-control" placeholder="Enter Link*" id="link" />
                                    {errors.link && <span className="text-danger d-block error">{errors.link.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label for="seconds">Seconds<span className="text-danger">*</span></Label>
                                    <input {...popupInput("seconds", { required: 'Please Enter seconds' })} className="form-control-sm form-control" placeholder="Enter seconds*" id="seconds" />
                                    {errors.seconds && <span className="text-danger d-block error">{errors.seconds.message}</span>}
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <FormGroup check className="pl-0">
                                        <Label>Status<span className="text-danger">*</span></Label>
                                        <div>
                                            <span className="form-check2 me-3">
                                                <input className="mx-2" {...popupInput("status", { required: true })} type="radio" value="1" id="active_add" />
                                                <Label for="active_add">Active</Label>
                                            </span>
                                            <span className="form-check2">
                                                <input className="mx-2" {...popupInput("status", { required: true })} type="radio" value="0" id="inactive_add" />
                                                <Label for="inactive_add">InActive</Label>
                                            </span>
                                        </div>
                                    </FormGroup>
                                </FormGroup>
                            </Col>
                            <Col sm={12} className="text-right">
                                <Button className="vs-btn border-0" color="primary">Save</Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default AddPopop